<template>
  <div class="wrapper">
    <SidebarHeader title="配信エリア" />
    <SidebarRadiusSetting :form="form" :readonly="readonly" />
    <SidebarHeader title="配信地点グループ設定" />
    <SidebarLocationGroupList
      :form="form"
      :readonly="readonly"
      @changeIsSelectedPoiLocationGroup="changeIsSelectedPoiLocationGroup"
    />
  </div>
</template>

<script>
import SidebarHeader from '@/components/Shared/Simulation/SimulationContentDeliverySidebarHeader'
import SidebarRadiusSetting from '@/components/Shared/Simulation/SimulationContentDeliverySidebarRadiusSetting'
import SidebarLocationGroupList from '@/components/Shared/Simulation/SimulationContentDeliverySidebarLocationGroupList'
import { mapGetters } from 'vuex'
import { modes } from '@/vuex/modules/simulation/constants'

export default {
  name: 'SimulationModelContentDeliverySidebar',
  components: {
    SidebarLocationGroupList,
    SidebarRadiusSetting,
    SidebarHeader,
  },
  props: {
    form: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showLocationBulkAddModal: false,
    }
  },
  computed: {
    ...mapGetters('simulation', ['selectedGroupId']),
    ...mapGetters('simulation', ['mode']),
    readonly() {
      return this.mode === modes.READONLY
    },
    deliverySetting() {
      return this.form.deliverySetting
    },
    menuSetting() {
      return this.form.deliverySetting.menuSetting
    },
    currentSelectedGroup() {
      return this.menuSetting.simulationLocationGroups.getGroup(
        this.selectedGroupId,
      )
    },
    simulationLocationGroups() {
      return this.menuSetting.simulationLocationGroups.getGroups()
    },
    locations() {
      return this.currentSelectedGroup.simulationLocations
    },
  },
  methods: {
    changeIsSelectedPoiLocationGroup(status) {
      this.$emit('changeIsSelectedPoiLocationGroup', status)
    },
  },
}
</script>

<style scoped>
.wrapper {
  border-right: 1px solid #e8e8e8;
}
.wrapper ::v-deep .v-text-field {
  margin: 0;
  padding: 0;
}

.wrapper ::v-deep .v-input--selection-controls {
  padding: 0;
  margin: 0;
}

.wrapper ::v-deep .v-messages {
  min-height: 0;
}

.wrapper ::v-deep .v-input {
  flex: initial;
}
</style>
